var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconQrCode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M6 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2H2v4h4zm0 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 2H2v4h4z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 10,
  y: 10,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 15,
  y: 10,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 15,
  y: 15,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 10,
  y: 15,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M16 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2h-4v4h4z"
}))));
export default SvgIconQrCode;